import CleaningService from "@/templates/hero/cleaning-service-2";
import CareerServices from "@/templates/hero/career-services";
import ArtStore from "@/templates/hero/art-store";
import LandscapePhotographer from "@/templates/hero/landscape-photographer";
import PersonalWebsite from "@/templates/hero/personal-website";
import FashionRetailer from "@/templates/hero/beauty-shop";
import BakeryStore from "@/templates/hero/bakery-store";
import BeautyShop from "@/templates/hero/beauty-shop-slides";
import ParentingBlog from "@/templates/hero/parenting-blog";
import Yoga from "@/templates/hero/yoga";
import Spa from "@/templates/hero/spa";
import LogisticFreight from "@/templates/hero/logistics-freight";
import JewelryStore from "@/templates/hero/jewelry-store";
import SandwichShop from "@/templates/hero/sandwich-shop";
import HandymanHero from "../templates/hero/handyman";
import MusicStore from "../templates/hero/music-store";

// v2 hero templates from shared package
import {
  PetSitterHero as PetSitter,
  PetSitter1Hero as PetSitter1,
  PetSitter2Hero as PetSitter2,
  PetSitter3Hero as PetSitter3,
  SpaHero as MenSpa,
  Spa1Hero as MenSpa1,
  Spa2Hero as MenSpa2,
  Spa3Hero as MenSpa3,
  // Spa4Hero as MenSpa4,
  LawZipHero as LawZip,
  LawZip1Hero as LawZip1,
  LawZip2Hero as LawZip2,
  LawZip3Hero as LawZip3,
  MaxFitHero as MaxFit,
  MaxFit1Hero as MaxFit1,
  MaxFit2Hero as MaxFit2,
  MaxFit3Hero as MaxFit3,
  ShampooConditionerHero as ShampooConditioner,
  ShampooConditioner1Hero as ShampooConditioner1,
  ShampooConditioner2Hero as ShampooConditioner2,
  ShampooConditioner3Hero as ShampooConditioner3,
  ShampooConditioner4Hero as ShampooConditioner4,
  ShampooConditioner5Hero as ShampooConditioner5,
} from '@siteplus/ai-templates';

export const templateConfig = {
  professional: [
    {
      id: "75a3d801-89b2-4ac5-8fdc-a889eb7cfac1",
      name: "Law Zip",
      templates: [
        {
          template: LawZip,
          id: "6c08cbea-d7a5-4ed1-beb8-a5314f905799",
          coverId: "cover",
        },
        {
          template: LawZip1,
          id: "153f6c1e-6075-4699-9690-3aa02eab46f9",
          coverId: "cover2",
        },
        {
          template: LawZip2,
          id: "153f6c1e-6075-4699-9690-3aa02eab46f9",
          coverId: "cover3",
        },
        {
          template: LawZip3,
          id: "6c08cbea-d7a5-4ed1-beb8-a5314f905799",
          coverId: "cover4",
        }
      ],
      version: "v2",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#651D31",
            },
            secondary: {
              main: "#D4A6A9",
            },
            text: {
              primary: "#000000",
              secondary: "#FDFDFD",
            },
            background: {
              paper: "#FFF3F2",
              container: "#CDD6DC",
            },
            textColor: "#000000",
          },
          typography: {
            fontFamily: "Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          header: {
            title: "Cleaning services",
          },
          hero: {
            title: "Incredible cleaning services",
            subtitle2: "LET'S GET STARTED",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            ctaText: "555-555-5555",
            orientation: "landscape",
            backgroundImage: "",
          },
          navigation: {
            hasShoppingCart: false
          },
        },
        fields: [
          {
            name: "sections.hero.subtitle",
            type: "textarea",
            label: "Subtitle",
          },
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
          {
            name: "sections.hero.ctaText",
            type: "textfield",
            label: "Button text",
          },
        ],
        buttonStyle: "rounded-corners",
        buttonFont: "body",
        supportedSections: {
          header_and_introduction: true,
          aboutUs: true,
          dashstore: true,
          dashbooking: true,
          features: true,
          advantages: true,
          gallery: true,
        }
      },
    },
    {
      id: "529c6dbc-ed74-4783-82f4-d445ce6a0530",
      name: "Logistic & Freight",
      template: LogisticFreight,
      version: "v1",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#000000",
            },
            secondary: {
              main: "#ffffff",
            },
            textColor: "#000000",
          },
          typography: {
            fontFamily: "Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "https://static.edit.site/static/657/logo.svg",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          hero: {
            title: "Incredible cleaning services",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            ctaText: "555-555-5555",
            orientation: "landscape",
            backgroundImage: "",
          },
          navigation: {
            links: ["About", "Why Choose Us", "Services", "Pricing"],
            ctaText: "Book Now",
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
          {
            name: "sections.hero.subtitle",
            type: "textarea",
            label: "Subtitle",
          },
          {
            name: "sections.hero.ctaText",
            type: "textfield",
            label: "Button text",
          },
        ],
        buttonStyle: "rounded-corners",
        supportedSections: {
          header_and_introduction: true,
          advantages: true,
          dashstore: true,
          dashbooking: true,
          services: true,
          features: true,
          aboutUs: true,
          solutions: true,
          gallery: true,
          callToAction1: true,
          contact_form: true,
        }
      },
    },
    {
      id: "6d773191-610e-47eb-a74b-3cadb33ead1f",
      name: "Landscape Photographer",
      template: LandscapePhotographer,
      version: "v1",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#000000",
            },
            secondary: {
              main: "#ffffff",
            },
            textColor: "#000000",
          },
          typography: {
            fontFamily: "Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "https://static.edit.site/static/657/logo.svg",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          hero: {
            title: "Incredible cleaning services",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            ctaText: "555-555-5555",
            orientation: "landscape",
            backgroundImage: "",
          },
          navigation: {
            links: ["About", "Why Choose Us", "Services", "Pricing"],
            ctaText: "Book Now",
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
          {
            name: "sections.hero.subtitle",
            type: "textarea",
            label: "Subtitle",
          },
          {
            name: "sections.hero.ctaText",
            type: "textfield",
            label: "Button text",
          },
        ],
        supportedSections: {
          header_and_introduction: true,
          aboutUs: true,
          dashstore: true,
          dashbooking: true,
          gallery: true,
          callToAction1: true,
          features: true,
          portfolio: true,
          footer: true,
        }
      },
    },
    {
      id: "7d4cf99b-c2bc-4790-996c-ba9f6bfd1bb7",
      name: "Career Services",
      template: CareerServices,
      version: "v1",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#0D809D",
            },
            secondary: {
              main: "#FCC44C",
            },
            text: {
              primary: "#222222",
              secondary: "#ffffff",
            },
            background: {
              paper: "#F4F5F7",
            },
            textColor: "#000000",
          },
          typography: {
            fontFamily: "Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          hero: {
            title: "Incredible cleaning services",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            ctaText: "555-555-5555",
            orientation: "landscape",
            backgroundImage: "",
          },
          navigation: {
            hasShoppingCart: false
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
          {
            name: "sections.hero.subtitle",
            type: "textarea",
            label: "Subtitle",
          },
          {
            name: "sections.hero.ctaText",
            type: "textfield",
            label: "Button text",
          },
        ],
        buttonStyle: "rounded-corners",
        supportedSections: {
          header_and_introduction: true,
          dashstore: true,
          dashbooking: true,
          features: true,
          steps: true,
          testimonials: true,
          logos: true,
          events: true,
        }
      },
    },
  ],
  playful: [
    {
      id: "0c3f5491-7594-43d0-9fa8-b42877c50732",
      name: "PetSitter",
      templates: [
        {
          template: PetSitter,
          id: "0c3f5491-7594-43d0-9fa8-b42877c50732",
          coverId: "cover11",
        },
        {
          template: PetSitter1,
          id: "0c3f5491-7594-43d0-9fa8-b42877c50732",
          coverId: "cover2",
        },
        {
          template: PetSitter2,
          id: "0c3f5491-7594-43d0-9fa8-b42877c50732",
          coverId: "cover33",
        },
        {
          template: PetSitter3,
          id: "0c3f5491-7594-43d0-9fa8-b42877c50732",
          coverId: "cover4",
        }
      ],
      version: "v2",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#F9A392",
            },
            secondary: {
              main: "#8ED4CC",
            },
            text: {
              primary: "#424242",
              secondary: "#ffffff",
            },
            background: {
              paper: "#F6F4F1",
            },
            textColor: "#000000",
          },
          typography: {
            fontFamily: "Orelega One, Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          hero: {
            title: "Incredible cleaning services",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            ctaText: "555-555-5555",
            orientation: "landscape",
            backgroundImage: "",
          },
          navigation: {
            links: ["About", "Why Choose Us", "Services", "Pricing"],
            ctaText: "Book Now",
            hasShoppingCart: false
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
          {
            name: "sections.hero.ctaText",
            type: "textfield",
            label: "Button text",
          },
        ],
        buttonStyle: "circular-corners",
        buttonFont: "body",
        supportedSections: {
          header_and_introduction: true,
          dashstore: true,
          dashbooking: true,
          services: true,
          features: true,
          callToAction1: true,
          prices: true,
          gallery: true,
          aboutUs: true,
          team: true,
          contact_form: true,
          footer: true,
        }
      },
    },
    {
      id: "6e2b0262-980d-4ada-b5ab-ec77816220e3",
      name: "Spa",
      template: Spa,
      version: "v1",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#F9A392",
            },
            secondary: {
              main: "#8ED4CC",
            },
            text: {
              primary: "#424242",
              secondary: "#ffffff",
            },
            background: {
              paper: "#F6F4F1",
            },
            textColor: "#000000",
          },
          typography: {
            fontFamily: "Orelega One, Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          hero: {
            title: "Incredible cleaning services",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            ctaText: "555-555-5555",
            orientation: "landscape",
            backgroundImage: "",
          },
          navigation: {
            links: ["About", "Why Choose Us", "Services", "Pricing"],
            ctaText: "Book Now",
            hasShoppingCart: false
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
          {
            name: "sections.hero.subtitle",
            type: "textarea",
            label: "Subtitle",
          },
          {
            name: "sections.hero.ctaText",
            type: "textfield",
            label: "Button text",
          },
        ],
        buttonStyle: "rounded-corners",
        supportedSections: {
          header_and_introduction: true,
          dashstore: true,
          dashbooking: true,
          services: true,
          features: true,
          callToAction1: true,
          prices: true,
          gallery: true,
          aboutUs: true,
          team: true,
          contact_form: true,
          footer: true,
        }
      },
    },
    {
      id: "26c9a60c-977d-4afd-b7da-3c1ea8d5255e",
      name: "Art Store",
      template: ArtStore,
      version: "v1",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#000000",
            },
            secondary: {
              main: "#ffffff",
            },
            textColor: "#000000",
          },
          typography: {
            fontFamily: "Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        buttonStyle: "rounded-corners",
        logo: {
          src: "https://static.edit.site/static/657/logo.svg",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          hero: {
            title: "Incredible cleaning services",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            ctaText: "555-555-5555",
            backgroundImage: "",
          },
          navigation: {
            links: ["About", "Why Choose Us", "Services", "Pricing"],
            ctaText: "Book Now",
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
          {
            name: "sections.hero.subtitle",
            type: "textarea",
            label: "Subtitle",
          },
          {
            name: "sections.hero.ctaText",
            type: "textfield",
            label: "Button text",
          },
        ],
        supportedSections: {
          header_and_introduction: true,
          categories: true,
          dashstore: true,
          dashbooking: true,
          callToAction1: true,
          advantages: true,
          dashstore2: true,
          dashbooking2: true,
          footer: true,
        }
      },
    },
    {
      id: "939afb48-db93-45d6-ad72-ed36e241ad12",
      name: "Music Store",
      template: MusicStore,
      version: "v1",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#000000",
            },
            secondary: {
              main: "#ffffff",
            },
            textColor: "#000000",
          },
          typography: {
            fontFamily: "Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "https://static.edit.site/static/657/logo.svg",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          header: {
            title: "Music",
          },
          hero: {
            title: "Incredible cleaning services",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            ctaText: "555-555-5555",
            orientation: "landscape",
            backgroundImage: "",
          },
          navigation: {
            links: ["About", "Why Choose Us", "Services", "Pricing"],
            ctaText: "Book Now",
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
          {
            name: "sections.hero.subtitle",
            type: "textarea",
            label: "Subtitle",
          },
          {
            name: "sections.hero.ctaText",
            type: "textfield",
            label: "Button text",
          },
        ],
        supportedSections: {
          header: true,
          header_and_introduction: true,
          dashstore: true,
          dashbooking: true,
          advantages: true,
          callToAction1: true,
          dashstore2: true,
          dashbooking2: true,
          aboutUs: true,
          footer: true,
        }
      },
    },
    {
      id: "1890515f-44ae-4b47-ae73-1536386d58c3",
      name: "Yoga",
      template: Yoga,
      version: "v1",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#000000",
            },
            secondary: {
              main: "#ffffff",
            },
            textColor: "#000000",
          },
          typography: {
            fontFamily: "Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "https://static.edit.site/static/657/logo.svg",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          hero: {
            title: "Incredible cleaning services",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            ctaText: "555-555-5555",
            orientation: "squarish",
            backgroundImage: "",
          },
          navigation: {
            links: ["About", "Why Choose Us", "Services", "Pricing"],
            ctaText: "Book Now",
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
          {
            name: "sections.hero.subtitle",
            type: "textarea",
            label: "Subtitle",
          },
          {
            name: "sections.hero.ctaText",
            type: "textfield",
            label: "Button text",
          },
        ],
        supportedSections: {
          header_and_introduction: true,
          dashstore: true,
          dashbooking: true,
          features: true,
          team: true,
          aboutUs: true,
          citation: true,
          testimonials: true,
          callToAction1: true,
        }
      },
    },
  ],
  modern: [
    {
      id: "5ed43ef1-e39f-4279-93a0-c899246ae7c0",
      name: "Men Spa",
      templates: [
        {
          template: MenSpa,
          id: "5ed43ef1-e39f-4279-93a0-c899246ae7c0",
          coverId: "cover11",
        },
        {
          template: MenSpa1,
          id: "5ed43ef1-e39f-4279-93a0-c899246ae7c0",
          coverId: "cover22",
        },
        {
          template: MenSpa2,
          id: "5ed43ef1-e39f-4279-93a0-c899246ae7c0",
          coverId: "cover33",
        },
        {
          template: MenSpa3,
          id: "5ed43ef1-e39f-4279-93a0-c899246ae7c0",
          coverId: "cover44",
        },
      ],
      version: "v2",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#7392ff",
            },
            secondary: {
              main: "#444655",
            },
            text: {
              primary: "#0e0e0e",
              secondary: "#ffffff",
            },
            background: {
              paper: "#EBEEFF"
            },
            textColor: "#ffffff",
          },
          typography: {
            fontFamily: "Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          hero: {
            title: "Incredible cleaning services",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            ctaText: "555-555-5555",
            orientation: "portrait",
            backgroundImage: "",
          },
          navigation: {
            links: ["About", "Why Choose Us", "Services", "Pricing"],
            ctaText: "Book Now",
            hasShoppingCart: false
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
          {
            name: "sections.hero.subtitle",
            type: "textarea",
            label: "Subtitle",
          },
          {
            name: "sections.hero.ctaText",
            type: "textfield",
            label: "Button text",
          },
        ],
        buttonStyle: "circular-corners",
        supportedSections: {
          header_and_introduction: true,
          dashstore: true,
          dashbooking: true,
          features: true,
          callToAction1: true,
          services: true,
          callToAction2: true,
          prices: true,
          contact_form: true
        }
      },
    },
    {
      id: "9937a286-32ea-4e6e-88f4-7446c4dc738f",
      darkId: "6251d8ed-96c6-41f5-8097-b55472c062cc",
      name: "Cleaning Services",
      template: CleaningService,
      version: "v1",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#7392ff",
            },
            secondary: {
              main: "#444655",
            },
            text: {
              primary: "#0e0e0e",
              secondary: "#ffffff",
            },
            background: {
              paper: "#EBEEFF"
            },
            textColor: "#ffffff",
          },
          typography: {
            fontFamily: "Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          hero: {
            title: "Incredible cleaning services",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            ctaText: "555-555-5555",
            orientation: "portrait",
            backgroundImage: "",
          },
          navigation: {
            links: ["About", "Why Choose Us", "Services", "Pricing"],
            ctaText: "Book Now",
            hasShoppingCart: false
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
          {
            name: "sections.hero.subtitle",
            type: "textarea",
            label: "Subtitle",
          },
          {
            name: "sections.hero.ctaText",
            type: "textfield",
            label: "Button text",
          },
        ],
        buttonStyle: "circular-corners",
        supportedSections: {
          header_and_introduction: true,
          dashstore: true,
          dashbooking: true,
          features: true,
          callToAction1: true,
          services: true,
          callToAction2: true,
          prices: true,
          contact_form: true
        }
      },
    },
    {
      id: "2815bb2f-10f5-4d7a-979f-3552504abd43",
      name: "Personal Website",
      template: PersonalWebsite,
      version: "v1",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#000000",
            },
            secondary: {
              main: "#ffffff",
            },
            textColor: "#000000",
          },
          typography: {
            fontFamily: "Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "https://static.edit.site/static/657/logo.svg",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          hero: {
            title: "Incredible cleaning services",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            ctaText: "555-555-5555",
            orientation: "landscape",
            backgroundImage: "",
          },
          navigation: {
            links: ["About", "Why Choose Us", "Services", "Pricing"],
            ctaText: "Book Now",
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
          {
            name: "sections.hero.subtitle",
            type: "textarea",
            label: "Subtitle",
          },
          {
            name: "sections.hero.ctaText",
            type: "textfield",
            label: "Button text",
          },
        ],
        buttonStyle: "rounded-corners",
        supportedSections: {
          header_and_introduction: true,
          dashstore: true,
          dashbooking: true,
          features: true,
          callToAction1: true,
          aboutUs: true,
          testimonials: true,
          callToAction2: true,
          contact_form: true
        }
      },
    },
    {
      id: "127b642e-1e58-4917-a5ac-56769138e13e",
      name: "Bakery Store",
      template: BakeryStore,
      version: "v1",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#000000",
            },
            secondary: {
              main: "#ffffff",
            },
            textColor: "#000000",
          },
          typography: {
            fontFamily: "Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "https://static.edit.site/static/657/logo.svg",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          hero: {
            title: "Incredible cleaning services",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            ctaText: "555-555-5555",
            orientation: "landscape",
            backgroundImage: "",
          },
          navigation: {
            links: ["About", "Why Choose Us", "Services", "Pricing"],
            ctaText: "Book Now",
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
        ],
        supportedSections: {
          header_and_introduction: true,
          aboutUs: true,
          dashstore: true,
          dashbooking: true,
          features: true,
          advantages: true,
          gallery: true,
        }
      },
    },
  ],
  bold: [
    {
      id: "043808e9-5440-4359-a5e0-c82e08dd1cca",
      name: "Max Fit",
      templates: [
        {
          template: MaxFit,
          id: "043808e9-5440-4359-a5e0-c82e08dd1cca",
          coverId: "cover11",
        },
        {
          template: MaxFit1,
          id: "043808e9-5440-4359-a5e0-c82e08dd1cca",
          coverId: "cover2",
        },
        {
          template: MaxFit2,
          id: "043808e9-5440-4359-a5e0-c82e08dd1cca",
          coverId: "cover33",
        },
        {
          template: MaxFit3,
          id: "043808e9-5440-4359-a5e0-c82e08dd1cca",
          coverId: "cover4",
        }
      ],
      version: "v2",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#FF7B43",
            },
            secondary: {
              main: "#86CECA",
            },
            text: {
              primary: "#0F0E13",
              secondary: "#FBFAF1",
            },
            background: {
              paper: "#FBFAF1",
            },
            textColor: "#000000",
          },
          backgroundColor: "#ff7b43",
          typography: {
            fontFamily: "Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          hero: {
            title: "Incredible cleaning services",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            ctaText: "555-555-5555",
            orientation: "squarish",
            backgroundImage: "",
          },
          navigation: {
            hasShoppingCart: false
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
        ],
        buttonStyle: "default",
        supportedSections: {
          header_and_introduction: true,
          dashstore: true,
          dashbooking: true,
          posts: true,
          testimonials: true,
          features: true,
          aboutUs: true,
          articles: true,
        }
      },
    },
    {
      id: "26ae90a0-2d33-4841-876b-b656bbbb707d",
      name: "Parenting Blog",
      template: ParentingBlog,
      version: "v1",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#FF7B43",
            },
            secondary: {
              main: "#86CECA",
            },
            text: {
              primary: "#0F0E13",
              secondary: "#FBFAF1",
            },
            background: {
              paper: "#FBFAF1",
            },
            textColor: "#000000",
          },
          backgroundColor: "#ff7b43",
          typography: {
            fontFamily: "Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          hero: {
            title: "Incredible cleaning services",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            ctaText: "555-555-5555",
            orientation: "squarish",
            backgroundImage: "",
          },
          navigation: {
            hasShoppingCart: false
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
          {
            name: "sections.hero.subtitle",
            type: "textarea",
            label: "Subtitle",
          },
          {
            name: "sections.hero.ctaText",
            type: "textfield",
            label: "Button text",
          },
        ],
        buttonStyle: "default",
        supportedSections: {
          header_and_introduction: true,
          dashstore: true,
          dashbooking: true,
          posts: true,
          testimonials: true,
          features: true,
          aboutUs: true,
          articles: true,
        }
      },
    },
    {
      id: "42167141-516c-4051-b7bb-8525cff02f43",
      name: "Sandwich Shop",
      template: SandwichShop,
      version: "v1",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#fc5320",
            },
            secondary: {
              main: "#ffffff",
            },
            text: {
              primary: "#1b1b1b",
              secondary: "#ffffff",
            },
            background: {
              paper: "#FEE8D0",
            },
            textColor: "#000000",
          },
          typography: {
            fontFamily: "Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          hero: {
            title: "Incredible cleaning services",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            ctaText: "555-555-5555",
            orientation: "landscape",
            backgroundImage: "",
          },
          navigation: {
            links: ["About Us", "Menu", "Catering", "Contacts"],
            ctaText: "555-555-5555",
            hasShoppingCart: false,
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
        ],
        buttonStyle: "circular-corners",
        supportedSections: {
          header_and_introduction: true,
          aboutUs: true,
          dashstore: true,
          dashbooking: true,
          prices: true,
          features: true,
          gallery: true,
          contact_form: true,
        }
      },
    },
    {
      id: "dd774286-372a-4745-8829-d6bcb08370a6",
      name: "Handyman",
      template: HandymanHero,
      version: "v1",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#cea13e",
            },
            secondary: {
              main: "#ffffff",
            },
            text: {
              primary: "#cea13e",
              secondary: "#ffffff",
            },
            background: {
              paper: "#24242299",
            },
            textColor: "#000000",
          },
          typography: {
            fontFamily: "Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          hero: {
            title: "Incredible cleaning services",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            ctaText: "555-555-5555",
            orientation: "landscape",
            backgroundImage: "",
          },
          navigation: {
            links: ["How it works", "Pricing", "Gallery", "Partners"],
            ctaText: "555-555-5555",
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
          {
            name: "sections.hero.subtitle",
            type: "textarea",
            label: "Subtitle",
          },
          {
            name: "sections.hero.ctaText",
            type: "textfield",
            label: "Button text",
          },
        ],
        buttonStyle: "default",
        supportedSections: {
          header_and_introduction: true,
          dashstore: true,
          dashbooking: true,
          services: true,
          features: true,
          contact_form: true,
          testimonials: true,
          steps: true,
          callToAction1: true,
          gallery: true,
          callToAction2: true,
        }
      },
    },
  ],
  classic: [
    {
      id: "9cdab1fc-9b71-4a2b-86e4-1fdf6273a4c2",
      name: "Shampoo Conditioner",
      templates: [
      
        {
          template: ShampooConditioner2,
          id: "9cdab1fc-9b71-4a2b-86e4-1fdf6273a4c2",
          coverId: "cover33",
        },
        {
          template: ShampooConditioner3,
          id: "9cdab1fc-9b71-4a2b-86e4-1fdf6273a4c2",
          coverId: "cover44",
        },
        {
          template: ShampooConditioner4,
          id: "9cdab1fc-9b71-4a2b-86e4-1fdf6273a4c2",
          coverId: "cover6",
        },
        {
          template: ShampooConditioner5,
          id: "9cdab1fc-9b71-4a2b-86e4-1fdf6273a4c2",
          coverId: "cover7",
        },
        {
          template: ShampooConditioner,
          id: "9cdab1fc-9b71-4a2b-86e4-1fdf6273a4c2",
          coverId: "cover",
        },
        {
          template: ShampooConditioner1,
          id: "9cdab1fc-9b71-4a2b-86e4-1fdf6273a4c2",
          coverId: "cover2",
        },
      ],
      version: "v2",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#651D31",
            },
            secondary: {
              main: "#D4A6A9",
            },
            text: {
              primary: "#000000",
              secondary: "#FDFDFD",
            },
            background: {
              paper: "#FFF3F2",
              container: "#CDD6DC",
            },
            textColor: "#000000",
          },
          typography: {
            fontFamily: "Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          header: {
            title: "Cleaning services",
          },
          hero: {
            title: "Incredible cleaning services",
            subtitle2: "LET'S GET STARTED",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            ctaText: "555-555-5555",
            orientation: "landscape",
            backgroundImage: "",
          },
          navigation: {
            hasShoppingCart: false
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
          {
            name: "sections.hero.subtitle",
            type: "textarea",
            label: "Subtitle",
          },
          {
            name: "sections.hero.ctaText",
            type: "textfield",
            label: "Button text",
          },
        ],
        buttonStyle: "rounded-corners",
        buttonFont: "body",
        supportedSections: {
          header_and_introduction: true,
          aboutUs: true,
          dashstore: true,
          dashbooking: true,
          features: true,
          advantages: true,
          gallery: true,
        }
      },
    },
    {
      id: "23210ee7-ef96-40f7-9e34-52fd9385e5cd",
      name: "Beauty Store",
      template: BeautyShop,
      version: "v1",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#651D31",
            },
            secondary: {
              main: "#D4A6A9",
            },
            text: {
              primary: "#000000",
              secondary: "#FDFDFD",
            },
            background: {
              paper: "#FFF3F2",
              container: "#CDD6DC",
            },
            textColor: "#000000",
          },
          typography: {
            fontFamily: "Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          header: {
            title: "Cleaning services",
          },
          hero: {
            title: "Incredible cleaning services",
            subtitle2: "LET'S GET STARTED",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            ctaText: "555-555-5555",
            orientation: "landscape",
            backgroundImage: "",
          },
          navigation: {
            hasShoppingCart: false
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
          {
            name: "sections.hero.subtitle",
            type: "textarea",
            label: "Subtitle",
          },
          {
            name: "sections.hero.ctaText",
            type: "textfield",
            label: "Button text",
          },
        ],
        buttonStyle: "rounded-corners",
        supportedSections: {
          header_and_introduction: true,
          aboutUs: true,
          dashstore: true,
          dashbooking: true,
          features: true,
          advantages: true,
          gallery: true,
        }
      },
    },
    {
      id: "8d78c877-d862-4f93-820b-d4fa34ab3288",
      name: "Fashion Retailer",
      template: FashionRetailer,
      version: "v1",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#651d31",
            },
            secondary: {
              main: "#ffffff",
            },
            text: {
              primary: "#651d31",
              secondary: "#fdfdfd",
            },
            background: {
              container: "#651d31",
            },
            textColor: "#000000",
          },
          typography: {
            fontFamily: "Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          header: {
            title: "Tittle",
          },
          hero: {
            title: "Incredible cleaning services",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            subtitle2: "subtitle 2",
            ctaText: "555-555-5555",
            orientation: "landscape",
            backgroundImage: "",
          },
          navigation: {
            links: ["About", "Why Choose Us", "Services", "Pricing"],
            ctaText: "555-555-5555",
            hasShoppingCart: false,
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
          {
            name: "sections.hero.subtitle",
            type: "textarea",
            label: "Subtitle",
          },
          {
            name: "sections.hero.ctaText",
            type: "textfield",
            label: "Button text",
          },
        ],
        buttonStyle: "default",
        supportedSections: {
          header: true,
          header_and_introduction: true,
          gallery: true,
          dashstore: true,
          dashbooking: true,
          callToAction1: true,
          features: true,
          dashstore2: true,
          dashbooking2: true,
          advantages: true,
          callToAction2: true,
          footer: true,
        }
      },
    },
    {
      id: "34590a53-12a1-4ee8-bf78-3ea73d6c6c43",
      name: "Jewelry Store",
      template: JewelryStore,
      version: "v1",
      initialState: {
        theme: {
          palette: {
            primary: {
              main: "#fa34faf",
            },
            secondary: {
              main: "#ffffff",
            },
            textColor: "#000000",
          },
          typography: {
            fontFamily: "Arial, sans-serif", // Primary font
            secondaryFont: {
              fontFamily: "Georgia, serif", // Secondary font
            },
          },
        },
        logo: {
          src: "https://static.edit.site/static/657/logo.svg",
          fontFamily: "Arial, sans-serif",
          text: "Cleaning Services",
        },
        sections: {
          features: [
            {
              title: "Innovative",
            },
            {
              title: "Innovative",
            },
          ],
          hero: {
            title: "Incredible cleaning services",
            subtitle:
              "Professional window cleaning services for homes and businesses - trustworthy and reliable experts at your service",
            subtitle2: "this is subtitle 2",
            ctaText: "555-555-5555",
            orientation: "landscape",
            backgroundImage: "",
          },
          navigation: {
            links: ["About", "Why Choose Us", "Services", "Pricing"],
            ctaText: "Book Now",
          },
        },
        fields: [
          {
            name: "sections.hero.title",
            type: "textarea",
            label: "Headline",
          },
          {
            name: "sections.hero.subtitle",
            type: "textarea",
            label: "Subtitle",
          },
          {
            name: "sections.hero.ctaText",
            type: "textfield",
            label: "Button text",
          },
        ],
        supportedSections: {
          features: true,
          header_and_introduction: true,
          dashstore: true,
          dashbooking: true,
          categories: true,
          services: true,
          aboutUs: true,
          dashstore2: true,
          dashbooking2: true,
          gallery: true,
          advantages: true,
          footer: true,
        }
      },
    },
  ],
};
